var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKommunal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 214,
    viewBox: "0 0 219 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9506 59.3664V115.272L41.5429 126.972V47.6659L20.9506 59.3664Z",
    fill: "#628A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 60.6679L46.8448 59.0067V53.4471L52.407 55.1084V60.6679Z",
    fill: "#628A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 63.3423L56.0191 61.6811V56.116L61.5868 57.7772V63.3423Z",
    fill: "#628A3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 71.3604L46.8448 69.6992V64.1342L52.407 65.7954V71.3604Z",
    fill: "#628A3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 74.0296L56.0191 72.3684V66.8088L61.5868 68.4701V74.0296Z",
    fill: "#628A3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 82.0476L46.8448 80.3863V74.8268L52.407 76.488V82.0476Z",
    fill: "#628A3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 84.7224L56.0191 83.0612V77.4961L61.5868 79.1573V84.7224Z",
    fill: "#628A3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 92.7348L46.8448 91.0736V85.514L52.407 87.1753V92.7348Z",
    fill: "#628A3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 95.4094L56.0191 93.7481V88.1886L61.5868 89.8498V95.4094Z",
    fill: "#628A3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 103.428L46.8448 101.766V96.2068L52.407 97.868V103.428Z",
    fill: "#628A3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 106.102L56.0191 104.441V98.8757L61.5868 100.537V106.102Z",
    fill: "#628A3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 114.115L46.8448 112.454V106.894L52.407 108.555V114.115Z",
    fill: "#628A3F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 116.789L56.0191 115.128V109.569L61.5868 111.23V116.789Z",
    fill: "#628A3F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.407 124.807L46.8448 123.146V117.581L52.407 119.242V124.807Z",
    fill: "#628A3F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5868 127.476L56.0191 125.815V120.256L61.5868 121.917V127.476Z",
    fill: "#628A3F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3485 31.6299V149.792L96.3285 166.255V15.1672L67.3485 31.6299Z",
    fill: "#628A3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 31.2475L102.123 28.9107V21.0808L109.957 23.4176V31.2475Z",
    fill: "#628A3F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 35.0073L115.037 32.6706V24.8407L122.871 27.183V35.0073Z",
    fill: "#628A3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 46.2871L102.123 43.9503V36.126L109.957 38.4628V46.2871Z",
    fill: "#628A3F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 50.0469L115.037 47.7101V39.8857L122.871 42.2225V50.0469Z",
    fill: "#628A3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 61.3322L102.123 58.9954V51.1655L109.957 53.5079V61.3322Z",
    fill: "#628A3F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 65.0922L115.037 62.7554V54.931L122.871 57.2678V65.0922Z",
    fill: "#628A3F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 76.3772L102.123 74.0349V66.2106L109.957 68.5474V76.3772Z",
    fill: "#628A3F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 80.1371L115.037 77.7948V69.9705L122.871 72.3072V80.1371Z",
    fill: "#628A3F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 91.4168L102.123 89.0801V81.2557L109.957 83.5925V91.4168Z",
    fill: "#628A3F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 95.1766L115.037 92.8398V85.0155L122.871 87.3523V95.1766Z",
    fill: "#628A3F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 106.462L102.123 104.125V96.2953L109.957 98.6321V106.462Z",
    fill: "#628A3F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 110.222L115.037 107.885V100.055L122.871 102.392V110.222Z",
    fill: "#628A3F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.957 121.501L102.123 119.165V111.34L109.957 113.677V121.501Z",
    fill: "#628A3F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.871 125.261L115.037 122.925V115.1L122.871 117.437V125.261Z",
    fill: "#628A3F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M128.721 17.0719V139.581L158.77 156.653V0.00012207L128.721 17.0719Z",
    fill: "#628A3F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 16.6731L164.781 14.2477V6.12988L172.897 8.55526V16.6731Z",
    fill: "#628A3F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 20.5715L178.171 18.1461V10.0338L186.288 12.4537V20.5715Z",
    fill: "#628A3F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 32.2664L164.781 29.8466V21.7288L172.897 24.1541V32.2664Z",
    fill: "#628A3F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 36.1647L178.171 33.7449V25.6271L186.288 28.0525V36.1647Z",
    fill: "#628A3F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 47.8652L164.781 45.4398V37.3275L172.897 39.7474V47.8652Z",
    fill: "#628A3F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 51.7636L178.171 49.3382V41.226L186.288 43.6513V51.7636Z",
    fill: "#628A3F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 63.4641L164.781 61.0387V52.9209L172.897 55.3463V63.4641Z",
    fill: "#628A3F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 67.3625L178.171 64.9371V56.8248L186.288 59.2447V67.3625Z",
    fill: "#628A3F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 79.0573L164.781 76.6375V68.5197L172.897 70.945V79.0573Z",
    fill: "#628A3F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 82.9556L178.171 80.5358V72.418L186.288 74.8434V82.9556Z",
    fill: "#628A3F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 94.6563L164.781 92.2309V84.1187L172.897 86.5385V94.6563Z",
    fill: "#628A3F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 98.5546L178.171 96.1292V88.017L186.288 90.4423V98.5546Z",
    fill: "#628A3F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M172.897 110.255L164.781 107.83V99.7118L172.897 102.137V110.255Z",
    fill: "#628A3F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M186.288 114.154L178.171 111.728V103.616L186.288 106.036V114.154Z",
    fill: "#628A3F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53001 100.166C2.53001 100.166 -10.1179 181.599 55.7255 199.418C55.7255 199.418 41.0001 176.261 40.856 160.767C40.856 160.767 52.684 186.129 65.559 196.085C65.559 196.085 63.7364 172.18 74.8608 151.775C74.8608 151.775 68.6504 131.591 42.6565 123.811C16.6627 116.031 2.53001 100.166 2.53001 100.166Z",
    fill: "#628A3F",
    stroke: "white",
    strokeWidth: 2.70658,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9552 206.379C66.9552 206.379 56.695 146.143 106.843 123.606C156.992 101.069 182.138 112.919 217.406 80.8461C217.406 80.8461 220.298 138.047 175.784 179.943C131.269 221.839 74.3289 210.859 74.3289 210.859C74.3289 210.859 103.525 165.214 133.441 147.156C133.436 147.151 93.4033 152.5 66.9552 206.379Z",
    fill: "#628A3F",
    stroke: "white",
    strokeWidth: 2.70658,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKommunal);
export default __webpack_public_path__ + "static/media/logo-kommunal.574ed602b10331c5099d0a1b9d5c6489.svg";
export { ForwardRef as ReactComponent };